// extracted by mini-css-extract-plugin
export default {"container":"NewsletterSubscription_container__IZyT6","content":"NewsletterSubscription_content__5WvFP","form":"NewsletterSubscription_form__XOA9d"};